import { getSiteDomain } from 'utils/common';
import { ACTIVITY_MAXCAP_MAP } from 'constants/index';
import makeRequest from 'utils/makeRequest';
import {
  campaingHistoryNameWEB,
  campaingHistoryNameWAP,
} from 'modules/WithTimesPoint/config';
import { offersMapping } from './constants';
import reducerRegistry from '../../reduxUtils/reducerRegistry';

const reducerName = 'timespointmodal';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_USER_REWARDS = createActionName('RECEIVE_USER_REWARDS');
export const RECEIVE_FAQ = createActionName('RECEIVE_FAQ');
export const RECEIVE_USER_PROFILE = createActionName('RECEIVE_USER_PROFILE');
const SET_TIMESPOINT_VISIBLE = createActionName('SET_TIMESPOINT_VISIBLE');
export function setTimesPointNudgeVisible(isVisible) {
  return {
    type: SET_TIMESPOINT_VISIBLE,
    paylaod: isVisible,
  };
}

export const RECEIVE_DAILY_CHECKIN_DETAILS = createActionName(
  'RECEIVE_DAILY_CHECKIN_DETAILS',
);
export const RECEIVE_DAILY_CHECKIN_ERROR = createActionName(
  'RECEIVE_DAILY_CHECKIN_ERROR',
);
export const RECEIVE_ALL_ACTIVITIES = createActionName(
  'RECEIVE_ALL_ACTIVITIES',
);
export const RECEIVE_DAILY_ACTIVITY = createActionName(
  'RECEIVE_DAILY_ACTIVITY',
);

// function getUserId() {
//   return Cookie.get('ssoid') || Cookie.get('ssoId');
// }

function sanitizeResult(data) {
  let newData = data;
  if (typeof data === 'string') {
    newData = JSON.parse(data);
  }

  return newData;
}

function receiveUserRewardsError() {
  return {
    type: RECEIVE_USER_REWARDS,
    payload: [],
  };
}

function fetchFAQDataError() {
  return {
    type: RECEIVE_FAQ,
    payload: '',
  };
}

function fetchUserProfileError() {
  return {
    type: RECEIVE_USER_PROFILE,
    payload: '',
  };
}

function receiveDailyCheckInError() {
  return {
    type: RECEIVE_DAILY_CHECKIN_DETAILS,
    payload: [],
  };
}

function receiveDailyActivityError() {
  return {
    type: RECEIVE_DAILY_ACTIVITY,
    payload: {},
  };
}

function fetchAllActivitiesError() {
  return {
    type: RECEIVE_ALL_ACTIVITIES,
    payload: {},
  };
}

function fetchFAQData() {
  const url = `${getSiteDomain()}/tp_faq.cms?msid=76036519`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

function fetchAllActivitiesData(isWapView) {
  const templateName = __PROD__
    ? '/tpallactivities_v2.cms'
    : '/tpallactivities_dev.cms';
  const pfmQueryParam = `pfm=${isWapView ? 'msite' : 'web'}`;
  const url = `${getSiteDomain()}${templateName}?${pfmQueryParam}`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

function receiveUserRewards(val) {
  const data = sanitizeResult(val);
  const userRewards = [];
  if (
    data &&
    data.responseCode === 'TP_100' &&
    data.response &&
    data.response.offers
  ) {
    Object.keys(offersMapping).forEach(objKey => {
      if (offersMapping[objKey]) {
        let counter = 0;
        const noOfOffersTobeShown = offersMapping[objKey].offerCount || 0;
        const offersData = data.response.offers[objKey];
        if (offersData) {
          const noOfOffersReceived = offersData.length;
          if (noOfOffersTobeShown > 0 && noOfOffersReceived > 0) {
            const length = Math.min(noOfOffersReceived, noOfOffersTobeShown);
            for (; counter < length; counter += 1) {
              const offer = offersData[counter];
              userRewards.push(offer);
            }
          }
        }
      }
    });
  }
  return {
    type: RECEIVE_USER_REWARDS,
    payload: userRewards,
  };
}

function receiveUserProfile(val) {
  const data = sanitizeResult(val);
  let userProfile = {};
  if (data && data.response && data.responseCode === 'TP_100') {
    userProfile = data.response;
  }
  return {
    type: RECEIVE_USER_PROFILE,
    payload: userProfile,
  };
}

function receiveFAQData(data) {
  return {
    type: RECEIVE_FAQ,
    payload: data || '',
  };
}

function setActivityDataInLocalStore(data) {
  let counter = 0;
  const activityMap = {};
  if (data && data.length > 0 && typeof window.localStorage !== 'undefined') {
    for (; counter < data.length; counter += 1) {
      activityMap[data[counter].code] = data[counter].maxcap;
    }

    try {
      window.localStorage.setItem(
        ACTIVITY_MAXCAP_MAP,
        JSON.stringify(activityMap),
      );
    } catch (e) {
      // console.log(e);
    }
  }
}

function getReorderedList(activities, orderDetails) {
  let counter = 0;
  const reorderedArray = [];
  let activityIndex = -1;
  if (
    activities &&
    activities.length > 0 &&
    orderDetails &&
    orderDetails.length > 0
  ) {
    for (; counter < activities.length; counter += 1) {
      activityIndex = orderDetails.indexOf(activities[counter].code);
      if (activityIndex !== -1) {
        reorderedArray[activityIndex] = activities[counter];
      }
    }

    return reorderedArray;
  }

  return activities;
}

function receiveAllActivitiesData(data) {
  let allActivity = [];
  let activitiesMapList = {};
  if (
    data.activitiesList &&
    data.activitiesList.data &&
    data.activitiesList.data.activities
  ) {
    allActivity = getReorderedList(
      data.activitiesList.data.activities,
      data.activityOrder,
    );
    activitiesMapList = data.activitiesMap;
  }

  setActivityDataInLocalStore(allActivity);
  return {
    type: RECEIVE_ALL_ACTIVITIES,
    payload: {
      allActivity,
      activitiesMapList,
    },
  };
}

function receiveDailyCheckInDetails(val) {
  const data = sanitizeResult(val);
  let dailyCheckin = [];
  if (
    data &&
    data.response &&
    data.responseCode === 'TP_100' &&
    data.response.items &&
    data.response.items.length > 0
  ) {
    dailyCheckin = data.response.items;
  }
  return {
    type: RECEIVE_DAILY_CHECKIN_DETAILS,
    payload: dailyCheckin,
  };
}

function receiveDailyActivityDetails(val) {
  const data = sanitizeResult(val);
  let dailyActivity = {};
  if (
    data &&
    data.response &&
    data.responseCode === 'TP_100' &&
    data.response.activities
  ) {
    dailyActivity = data.response.activities;
  }
  return {
    type: RECEIVE_DAILY_ACTIVITY,
    payload: dailyActivity,
  };
}

function fetchUserProfile(dispatch) {
  if (typeof window.tpsdk === 'function') {
    window.tpsdk(
      'fetch',
      'userPoints',
      '',
      data => dispatch(receiveUserProfile(data)),
      error => dispatch(fetchUserProfileError(error)),
    );
  }
}

function fetchUserRewards(dispatch) {
  if (typeof window.tpsdk === 'function') {
    window.tpsdk(
      'fetch',
      'offerDetails',
      '',
      data => dispatch(receiveUserRewards(data)),
      error => dispatch(receiveUserRewardsError(error)),
    );
  }
}

function getDailyCheckInDetail(dispatch, getState) {
  const curDate = new Date().getTime();
  const period = 86400 * 1000 * 7;
  const sDate = curDate - period;
  const eDate = curDate + period;
  const appState = getState();
  const isMobile = appState.isMobile || false;
  // if (typeof tpsdk !== 'function') {
  //   fn.loadTpJS();
  //   fn.changeUserStatusHandler();
  // }

  if (typeof window.tpsdk === 'function') {
    window.tpsdk(
      'fetch',
      'campaignHistory',
      {
        sdate: sDate,
        edate: eDate,
        cname: isMobile ? campaingHistoryNameWAP : campaingHistoryNameWEB,
      },
      data => dispatch(receiveDailyCheckInDetails(data)),
      error => dispatch(receiveDailyCheckInError(error)),
    );
  }
}

function fetchDailyActivity(dispatch) {
  if (typeof window.tpsdk === 'function') {
    window.tpsdk(
      'fetch',
      'dailyReport',
      '',
      data => dispatch(receiveDailyActivityDetails(data)),
      error => dispatch(receiveDailyActivityError(error)),
    );
  }
}

export function loadDailyCheckInDetails() {
  return (dispatch, getState) => getDailyCheckInDetail(dispatch, getState);
}

export function loadUserRewards() {
  return dispatch => fetchUserRewards(dispatch);
}

export function loadDailyActivity() {
  return dispatch => fetchDailyActivity(dispatch);
}

export function getFAQData() {
  return dispatch =>
    fetchFAQData()
      .then(data => dispatch(receiveFAQData(data.data)))
      .catch(error => dispatch(fetchFAQDataError(error)));
}

export function getAllActivities(isWapView) {
  return dispatch =>
    fetchAllActivitiesData(isWapView)
      .then(data => dispatch(receiveAllActivitiesData(data.data)))
      .catch(error => dispatch(fetchAllActivitiesError(error)));
}

export function getUserProfile() {
  return dispatch => fetchUserProfile(dispatch);
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case SET_TIMESPOINT_VISIBLE:
      return {
        ...state,
        isTimesPointNudgeVisible: action.paylaod,
      };
    case RECEIVE_USER_REWARDS:
      return {
        ...state,
        userRewards: action.payload,
      };
    case RECEIVE_FAQ:
      return {
        ...state,
        faq: action.payload,
      };
    case RECEIVE_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload,
      };
    case RECEIVE_DAILY_CHECKIN_DETAILS:
      return {
        ...state,
        dailyCheckInDetails: action.payload,
      };
    case RECEIVE_ALL_ACTIVITIES:
      return {
        ...state,
        allActivity: action.payload.allActivity,
        activitiesMapList: action.payload.activitiesMapList,
      };
    case RECEIVE_DAILY_ACTIVITY:
      return {
        ...state,
        dailyActivity: action.payload,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
